import { SET_PARTNER_NAME, SET_USER_DETAILS_DATA } from './types';

const initMoneyPersonalLoan: {
  userDetails: any;
  partnerName: string;
} = {
  userDetails: {},
  partnerName: null,
};

export function moneyPersonalLoan(state = initMoneyPersonalLoan, action) {
  const { type, userDetails, partnerName } = action;

  switch (type) {
    case SET_USER_DETAILS_DATA:
      return { ...state, userDetails };

    case SET_PARTNER_NAME:
      return { ...state, partnerName };

    default:
      return state;
  }
}

